import React from 'react';
import ConservationBannerBat from './ConservationBannerBat';
import ConservationBannerOnePercent from './ConservationBannerOnePercent';
import ConservationBannerPangolin from './ConservationBannerPangolin';
import ConservationBannerPlatform from './ConservationBannerPlatform';
import If from './If';

export interface ConservationBannerProps {
  conservation?: string;
}

export default function ConservationBanner(props: ConservationBannerProps) {
  return (
    <>
      <If value={props.conservation === 'bat'}>
        <ConservationBannerBat></ConservationBannerBat>
      </If>
      <If value={props.conservation === 'pangolin'}>
        <ConservationBannerPangolin></ConservationBannerPangolin>
      </If>
      <If value={props.conservation === 'platform'}>
        <ConservationBannerPlatform></ConservationBannerPlatform>
      </If>

      <If value={!props.conservation || props.conservation === 'onePercent'}>
        <ConservationBannerOnePercent></ConservationBannerOnePercent>
      </If>
    </>
  );
}
